"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
/**
 * @template T
 * @typedef {object} State
 * @property {T} [value]
 * @property {unknown} [query]
 * @property {unknown} [error]
 */
/**
 * @template T
 * @param {() => Promise<T>} runQuery
 * @param {unknown[]} dependencies
 * @returns {{ value?: T, ready: boolean, error?: unknown }}
 */
const useAsyncValue = (runQuery, dependencies = []) => {
    const currentQuery = (0, react_1.useMemo)(() => {
        return {};
    }, [...dependencies]);
    const [state, setState] = /** @type {typeof useState<State<T>>} */ (react_1.useState)({});
    (0, react_1.useEffect)(() => {
        let canceled = false;
        try {
            runQuery()
                .then((newValue) => {
                if (!canceled) {
                    setState({
                        query: currentQuery,
                        value: newValue,
                    });
                }
            })
                .catch((err) => {
                if (!canceled) {
                    setState({
                        query: currentQuery,
                        error: err,
                    });
                }
            });
        }
        catch (err) {
            setState({
                query: currentQuery,
                error: err,
            });
        }
        return () => {
            canceled = true;
        };
    }, [setState, currentQuery, ...dependencies]);
    return {
        ready: state.query === currentQuery,
        value: state.value,
        error: state.error,
    };
};
exports.default = useAsyncValue;
//# sourceMappingURL=index.js.map